module.exports = __webpack_public_path__ + "static/media/license.96055d9a.png";